module.exports = __webpack_public_path__ + "img/HolmesHunter_Academic_Building-PE-t-23621-003.f0f4e2cd.jpg";